<div class="pick-your-number-wrap">
  <ion-row class="euro-million-wrapper">
    <ion-col class="euro-million-wrap" size="7">
      <img class="euro-million-logo" [src]="ticketData?.productDetails[ticketData.lotteryIndex]?.product_image"
        alt="euro-million-logo" />
        <h1 class="euro-million">{{ ticketData?.productDetails[ticketData.lotteryIndex]?.product_name }}</h1>
      </ion-col>
      <ion-col class="auto-pick-wrap" size="5">
        <p (click)="autoPick()" class="auto-pick">Auto pick</p>
      </ion-col>
    </ion-row>
    @if (regularTicketNumber && regularTicketNumber?.length) {
      <ion-row>
        @for (item of regularTicketNumber; track item) {
          <ion-col size="1.7142" class="pick-box-wrap">
            <div class="pick-box" [ngClass]="{ 'pick-box-color': item.isSelected }" (click)="selectRegularNumber(item)">
              {{ item.ticket }}
            </div>
          </ion-col>
        }
      </ion-row>
    }
    @if (specialTicketNumber && specialTicketNumber?.length) {
      <h2 class="special-number">Special numbers</h2>
    }
    <ion-row>
      @for (item of specialTicketNumber; track item) {
        <ion-col size="1.7142" class="special-pick-box-wrap">
          <div class="special-pick-box" [ngClass]="{ 'special-pick-box-color': item.isSelected }"
            (click)="selectSpecialTicket(item)">
            {{ item.ticket }}
          </div>
        </ion-col>
      }
    </ion-row>
    @if (
      !(
      regularPickNumberCount + specialPickNumberCount ===
      ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_regular +
      ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_special
      )
      ) {
      <div class="number-warning-wrap">
        <mat-icon class="warn-icon">warning</mat-icon>
        <p class="number-warning">
          {{
          ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_regular - regularPickNumberCount
          }} number
          @if (ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_special) {
            <span>
              and
              {{
              ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_special - specialPickNumberCount
              }}
              special number
            </span>
          }
          left to select
        </p>
      </div>
    }
    <div class="finish-picking-btn-wrap">
    <ion-button class="finish-picking-btn" color="secondary" (click)="finishPicking()" [disabled]="
        !(
          regularPickNumberCount + specialPickNumberCount ===
          ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_regular +
            ticketData.productDetails[ticketData.lotteryIndex].lotteryInfo.count_ball_special
        )
      ">Finish picking</ion-button>
    </div>
    <p class="back-arrow" (click)="back()"><span class="arrow">← </span> Back</p>
  </div>